import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '../../ui/Layout';

import TagsList from './TagsList';

export default ({ match }) => (
  <Layout route="tags">
    <Switch>
      <Route exact path={`${match.url}/`} component={TagsList} />
    </Switch>
  </Layout>
);



// WEBPACK FOOTER //
// ./src/components/routes/tags/Tags.js